import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import { Container } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { SelectURL as SELECT_URL } from 'Components/Api/CasaDMTAPI';
import {
    GetServiceCharge as SELECT_CHARGE,
    Deduct as DEDUCT_CHARGE
} from 'Components/Api/ServiceChargeDeductionAPI';
import HOCLoader from 'Components/Loader/HOCLoader';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import { AEPS_Onboarding } from 'Components/Helper/Messages';
const CustomContainer = HOCLoader(Container);

export const CasaUserOnbording = () => {
    const history = useHistory();
    const formRef = useRef();
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [URL, setURL] = useState('');
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [Message, setMessage] = useState('');
    const [status, setStatus] = useState('PROCESS');

    const getCharge = async () => {
        var requestObj = {
            ServiceID: AEPS_Onboarding
        };
        var request = JSON.stringify(requestObj);
        setLoading(true);
        const response = await SELECT_CHARGE(request);
        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }
        var data = JSON.parse(response.data);
        if (data > 0) {
            let request = {
                ServiceID: AEPS_Onboarding,
                Charge: data
            };
            setConfirmAlertRequest(request);
            setIsAlertOpen(true);
        } else {
            selectURL();
        }
    };
    const DeductCharge = async () => {
        var requestObj = {
            ServiceID: AEPS_Onboarding
        };
        var request = JSON.stringify(requestObj);
        const response = await DEDUCT_CHARGE(request);
        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        selectURL();
    };
    const selectURL = async () => {
        setSeverity('error');
        setResponseMessage('');
        setIsError(false);
        setLoading(true);

        const response = await SELECT_URL();
        setLoading(false);

        if (!response.isAuthorized) {
            LOGOUT();
            return;
        }

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);

            setStatus('FAILURE');
            setMessage(response.data);
            setIsAlertErrorOpen(true);
            return;
        }

        const data = JSON.parse(response.data);
        let params = {
            Mobile: data.MerchantMobile
        };
        if (data.Message === 'Merchant already onboarded on Pipe.') {
            history.push('/CS_SenderAuthentication', params);
            return;
        }

        if (data.Message === 'Merchant already onboarded successfully !') {
            history.push('/CS_SenderSearch', params);
            return;
        }

        if (data.Status === 'FAILURE') {
            setSeverity('error');
            setResponseMessage(data.Message);
            setIsError(true);

            setStatus(data.Status);
            setMessage(data.Message);
            setIsAlertErrorOpen(true);
            return;
        }
        setSeverity('success');
        setURL(data.Redirecturl);

        if (formRef.current) {
            formRef.current.submit();
        }
    };


    useEffect(() => {
        getCharge();
    }, []);

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <form ref={formRef} method="post" action={URL} target="_blank">
                <input
                    type="submit"
                    value="Redirect"
                    style={{ display: 'none' }}
                />
            </form>

            {isAlertErrorOpen ? (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            ) : null}

            {isAlertOpen ? (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="DMT"
                    message="Are you sure to do onbording?"
                    request={confirmAlertRequest}
                    positiveButtonClick={() => {
                        setIsAlertOpen(false);
                        DeductCharge();
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
